import React, { useState, useEffect } from 'react';
import logo_pink from '../assets/effie-logo3b-new-pink.svg'; 

const Header = () => {
  const [isNavOpen, setNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleNav = () => {
    setNavOpen((prev) => !prev);
  };

  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setNavOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navItems = [
    { name: 'Why Us', id: 'why' },
    { name: 'IP Protection', id: 'ip-section' },
    { name: 'Pricing', id: 'pricing' },
    { name: 'FAQ', id: 'faq' },

  ];

  // Dynamic text color for nav items (but not the button)
  const textColor = isScrolled ? 'text-fuchsia-500' : 'text-white';

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? 'bg-fuchsia-900' : 'bg-transparent'
      }`}
    >
      <nav
        className="flex items-center justify-between w-full max-w-[85rem] mx-auto py-4 px-4 sm:px-6 lg:px-8"
      >
        {/* Logo */}
        <a href="#" aria-label="Brand">
          <img src={logo_pink} className="h-10" alt="Effie Logo" />
        </a>

        {/* Hamburger Menu for Mobile */}
        <button
          onClick={toggleNav}
          className={`md:hidden p-2 rounded ${textColor} transition-all`}
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
        >
          {isNavOpen ? (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          )}
        </button>

        {/* Desktop Nav Items */}
        <div className="hidden md:flex items-center space-x-6">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => handleScrollTo(item.id)}
              className={`px-3 py-1 text-white text-sm rounded font-semibold hover:bg-white/10 transition-all`}
            >
              {item.name}
            </button>
          ))}
          <div className="ml-4">
            <a
              href="https://dashboard.effie.cx"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-cyan-500 text-white px-3 py-1 rounded hover:bg-cyan-600 transition-all text-sm font-semibold"
            >
              Login
            </a>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isNavOpen && (
        <div
          className={`md:hidden fixed z-40 w-full bg-fuchsia-900 transition-all duration-500 ${
            isNavOpen ? 'top-[64px]' : 'top-[-100%]'
          } ${isScrolled ? '' : 'bg-opacity-90'}`}
        >
          <div className="flex flex-col items-center py-6 space-y-4">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleScrollTo(item.id)}
                className="text-white text-lg font-semibold px-4 py-2 rounded transition-all"
              >
                {item.name}
              </button>
            ))}
            <div className="mt-4">
              <a
                href="https://dashboard.effie.cx"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cyan-500 text-white px-4 py-1.5 rounded hover:bg-cyan-600 transition-all text-lg font-semibold"
              >
                Login
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;